module.exports = __webpack_public_path__ + "static/media/roeseliana_roeselii_004_APA.6876817e.mp3";